/**
 * Where the legal pages live: the landing, not this app.
 *
 * They are built by `vite.landing.config.ts` into real files on a different
 * host, so the app has to link out to them rather than route to them. Two
 * places need the origin — onboarding, and the account menu — which is one
 * more than justifies a constant of its own.
 *
 * ⚠ **The app must reach these from somewhere a signed-in person can find.**
 * Art. 12(1) asks for the information in an "easily accessible form", and
 * until 2026-09-20 the only link was on the onboarding page: seen once,
 * before an account exists, and never again.
 */
export const LEGAL_ORIGIN: string =
  import.meta.env.VITE_LANDING_ORIGIN ?? 'https://ptitim.vmloskutov.com';

/** The pages, in the order a person is likely to want them. */
export const LEGAL_PAGES: ReadonlyArray<readonly [label: string, path: string]> = [
  ['Privacy', '/privacy'],
  ['Terms', '/terms'],
  ['Sub-processors', '/subprocessors'],
  ['Security', '/security'],
  ['Legal notice', '/legal'],
];
